import { render, staticRenderFns } from "./VideoSlide.vue?vue&type=template&id=8ffda9f4&scoped=true&"
import script from "./VideoSlide.vue?vue&type=script&lang=js&"
export * from "./VideoSlide.vue?vue&type=script&lang=js&"
import style0 from "./VideoSlide.vue?vue&type=style&index=0&id=8ffda9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffda9f4",
  null
  
)

export default component.exports